//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.api

import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.BestAvailableRequest
import com.tixforgigs.apax.models.CartMetaInfo
import com.tixforgigs.apax.models.CartOptionsRequest
import com.tixforgigs.apax.models.CartOptionsResponse
import com.tixforgigs.apax.models.CartRefreshRequest
import com.tixforgigs.apax.models.CartResponse
import com.tixforgigs.apax.models.ItemAddRequest
import com.tixforgigs.apax.models.ItemRemoveRequest
import com.tixforgigs.apax.models.ItemUpdateRequest
import com.tixforgigs.apax.models.VoucherRequest

import com.tixforgigs.apax.infrastructure.*
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.request.forms.formData
import io.ktor.client.engine.HttpClientEngine
import kotlinx.serialization.json.Json
import io.ktor.http.ParametersBuilder
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

open class CommonCartApi : ApiClient {

    constructor(
        baseUrl: String = ApiClient.BASE_URL,
        httpClientEngine: HttpClientEngine? = null,
        httpClientConfig: ((HttpClientConfig<*>) -> Unit)? = null,
        jsonSerializer: Json = ApiClient.JSON_DEFAULT
    ) : super(baseUrl = baseUrl, httpClientEngine = httpClientEngine, httpClientConfig = httpClientConfig, jsonBlock = jsonSerializer)

    constructor(
        baseUrl: String,
        httpClient: HttpClient
    ): super(baseUrl = baseUrl, httpClient = httpClient)

    /**
     * cart - BETA (version from:4.6 to:latest)
     * -
     * @param cartMetaInfo 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartDetails(cartMetaInfo: CartMetaInfo): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = cartMetaInfo

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * floorplan best available - BETA (version from:4.6 to:latest)
     * -
     * @param bestAvailableRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartFloorplanBestavailable(bestAvailableRequest: BestAvailableRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = bestAvailableRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/floorplan/bestavailable",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Update cart - BETA (version from:4.6 to:latest)
     * -
     * @param itemAddRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartItemAdd(itemAddRequest: ItemAddRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = itemAddRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/add",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * remove cart item - BETA (version from:4.6 to:latest)
     * -
     * @param itemRemoveRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartItemRemove(itemRemoveRequest: ItemRemoveRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = itemRemoveRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/remove",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * update cart item - BETA (version from:4.6 to:latest)
     * Update a cart item (e.g. change ticket type)
     * @param itemUpdateRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartItemUpdate(itemUpdateRequest: ItemUpdateRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = itemUpdateRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.PUT,
            "/carts/cart/update",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Get options for current cart - BETA (version from:4.6 to:latest)
     * The options for current cart including available shippingMethods, terms and conditions
     * @param cartOptionsRequest 
     * @return CartOptionsResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartOptions(cartOptionsRequest: CartOptionsRequest): HttpResponse<CartOptionsResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = cartOptionsRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/options",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * refresh cart - BETA (version from:4.6 to:latest)
     * Refresh the current shoppingCart -&gt; recalculate prices/voucher-items/bookingFee while selecting payment/shippingMethod
     * @param cartRefreshRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartRefresh(cartRefreshRequest: CartRefreshRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = cartRefreshRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/refresh",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * apply voucher code - BETA (version from:4.6 to:latest)
     * Tries to apply a voucher code to the current cart.
     * @param voucherRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartVoucherApply(voucherRequest: VoucherRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = voucherRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/voucher/apply",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Remove voucher code - EXPERIMENTAL (version from:4.6 to:latest)
     * Removes the voucher code to the current cart.
     * @param voucherRequest 
     * @return CartResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun cartVoucherRemove(voucherRequest: VoucherRequest): HttpResponse<CartResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = voucherRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/carts/cart/voucher/remove",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



}
